import { GET_AUTOMATED_REPORT_FAILURE, GET_AUTOMATED_REPORT_REQUEST, GET_AUTOMATED_REPORT_SUCCESS, GET_AUTOMATED_REPORT_CLEAR, GetAutomatedReportActionTypes, GetAutomatedReportState } from './types';

const defaultState: GetAutomatedReportState = {
  isLoading: false,
  errorMessage: "",
};

export default function getAutomatedReport(state = defaultState, action: GetAutomatedReportActionTypes): GetAutomatedReportState {
  switch (action.type) {
    case GET_AUTOMATED_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_AUTOMATED_REPORT_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_AUTOMATED_REPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case GET_AUTOMATED_REPORT_CLEAR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "",
        contents: undefined
      };
    default:
      return state;
  }
};
